const products = [
  {
    id: 3,
    name: "Gaming Headset",
    price: 2499,
    image: "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb",
  },
  {
    id: 4,
    name: "Gaming Monitor",
    price: 18999,
    image: "https://images.unsplash.com/photo-1527443224154-c4a3942d3acf",
  },
  {
    id: 5,
    name: "Gaming Controller",
    price: 3499,
    image: "https://images.unsplash.com/photo-1592840496694-26d035b52b48",
  },
  {
    id: 6,
    name: "Gaming Chair",
    price: 12999,
    image: "https://images.unsplash.com/photo-1598550476439-6847785fcea6",
  },
  {
    id: 7,
    name: "Gaming Microphone",
    price: 4499,
    image: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc",
  },
  {
    id: 8,
    name: "Mousepad XL",
    price: 799,
    image: "https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89",
  },
  {
    id: 9,
    name: "Gaming Webcam",
    price: 5999,
    image: "https://images.unsplash.com/photo-1591405351990-4726e331f141",
  },
  {
    id: 10,
    name: "Gaming Desk",
    price: 17999,
    image: "https://images.unsplash.com/photo-1616588589676-62b3bd4ff6d2",
  },
  {
    id: 11,
    name: "Capture Card",
    price: 7499,
    image: "https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae",
  },
  {
    id: 12,
    name: "Gaming Speakers",
    price: 3999,
    image: "https://images.unsplash.com/photo-1545454675-3531b543be5d",
  },
  {
    id: 16,
    name: "Wireless Gaming Mouse",
    price: 2999,
    image: "https://images.unsplash.com/photo-1615663245857-ac93bb7c39e7",
  },
  {
    id: 18,
    name: "VR Headset",
    price: 34999,
    image: "https://images.unsplash.com/photo-1593508512255-86ab42a8e620",
  },
  {
    id: 19,
    name: "Gaming Router",
    price: 9999,
    image: "https://images.unsplash.com/photo-1606904825846-647eb07f5be2",
  },
  {
    id: 20,
    name: "USB Hub 7-Port",
    price: 1499,
    image: "https://images.unsplash.com/photo-1625895197185-efcec01cffe0",
  },
  {
    id: 21,
    name: "Gaming SSD 1TB",
    price: 7999,
    image: "https://images.unsplash.com/photo-1597872200969-2b65d56bd16b",
  },
  {
    id: 22,
    name: "RAM 16GB DDR5",
    price: 5999,
    image: "https://images.unsplash.com/photo-1562976540-1502c2145186",
  },
  {
    id: 23,
    name: "Graphics Card RTX",
    price: 49999,
    image: "https://images.unsplash.com/photo-1591488320449-011701bb6704",
  },
  {
    id: 24,
    name: "Gaming CPU Cooler",
    price: 3999,
    image: "https://images.unsplash.com/photo-1587202372775-e229f172b9d7",
  },
  {
    id: 25,
    name: "RGB Cabinet",
    price: 6999,
    image: "https://images.unsplash.com/photo-1547082299-de196ea013d6",
  },
  {
    id: 27,
    name: "Gaming Earbuds",
    price: 1999,
    image: "https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46",
  },
  {
    id: 28,
    name: "Monitor Arm",
    price: 2499,
    image: "https://images.unsplash.com/photo-1585771724684-38269d6639fd",
  },
  {
    id: 29,
    name: "Cable Management Kit",
    price: 499,
    image: "https://images.unsplash.com/photo-1601524909162-ae8725290836",
  },
  {
    id: 30,
    name: "Gaming Power Strip",
    price: 1299,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64",
  },
];

export default products;
